import type {Message} from '@bufbuild/protobuf';
import type {GenEnum, GenFile, GenMessage} from '@bufbuild/protobuf/codegenv2';
import {enumDesc, fileDesc, messageDesc} from '@bufbuild/protobuf/codegenv2';
import type {AccessibilityOverrides, AccessibilitySettings} from './accessibility_pb';
import {file_fluxer_user_preferences_v1_accessibility} from './accessibility_pb';
import type {
	EmojiPickerState,
	EmojiState,
	EmojiStickerLayoutSettings,
	FavoriteGifSettings,
	MemesPickerState,
	SoundSettings,
	StickerPickerState,
} from './pickers_pb';
import {file_fluxer_user_preferences_v1_pickers} from './pickers_pb';

/**
 * Describes the file fluxer/user/preferences/v1/preferences.proto.
 */
export const file_fluxer_user_preferences_v1_preferences: GenFile =
	/*@__PURE__*/
	fileDesc(
		'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',
		[file_fluxer_user_preferences_v1_accessibility, file_fluxer_user_preferences_v1_pickers],
	);

/**
 * @generated from message fluxer.user.preferences.v1.SyncedPreferences
 */
export type SyncedPreferences = Message<'fluxer.user.preferences.v1.SyncedPreferences'> & {
	/**
	 * @generated from field: fluxer.user.preferences.v1.AccessibilitySettings accessibility = 1;
	 */
	accessibility?: AccessibilitySettings | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.AccessibilityOverrides accessibility_overrides = 2;
	 */
	accessibilityOverrides?: AccessibilityOverrides | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.TextualPreviewSettings textual_preview = 3;
	 */
	textualPreview?: TextualPreviewSettings | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.EmojiPickerState emoji_picker = 20;
	 */
	emojiPicker?: EmojiPickerState | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.StickerPickerState sticker_picker = 21;
	 */
	stickerPicker?: StickerPickerState | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.MemesPickerState memes_picker = 22;
	 */
	memesPicker?: MemesPickerState | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.EmojiState emoji = 23;
	 */
	emoji?: EmojiState | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.EmojiStickerLayoutSettings emoji_sticker_layout = 24;
	 */
	emojiStickerLayout?: EmojiStickerLayoutSettings | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.FavoriteGifSettings favorite_gifs = 25;
	 */
	favoriteGifs?: FavoriteGifSettings | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.FavoritesState favorites = 40;
	 */
	favorites?: FavoritesState | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.RecentMentionsSettings recent_mentions = 41;
	 */
	recentMentions?: RecentMentionsSettings | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.SidebarPreferences sidebar = 42;
	 */
	sidebar?: SidebarPreferences | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.MemberListState member_list = 43;
	 */
	memberList?: MemberListState | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.UnreadChannelsState unread_channels = 44;
	 */
	unreadChannels?: UnreadChannelsState | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.MentionFrecencyState mention_frecency = 45;
	 */
	mentionFrecency?: MentionFrecencyState | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.NagbarDismissals nagbars = 60;
	 */
	nagbars?: NagbarDismissals | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.DismissedUpsells dismissed_upsells = 61;
	 */
	dismissedUpsells?: DismissedUpsells | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.GuildNsfwAgreements guild_nsfw_agreements = 62;
	 */
	guildNsfwAgreements?: GuildNsfwAgreements | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.WhatsNewState whats_new = 63;
	 */
	whatsNew?: WhatsNewState | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.PrivacyPreferences privacy = 80;
	 */
	privacy?: PrivacyPreferences | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.LocalUserSpamOverrides local_spam_overrides = 81;
	 */
	localSpamOverrides?: LocalUserSpamOverrides | undefined;

	/**
	 * @generated from field: bool sanitize_urls = 82;
	 */
	sanitizeUrls: boolean;

	/**
	 * @generated from field: fluxer.user.preferences.v1.SoundSettings sound = 100;
	 */
	sound?: SoundSettings | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.SpellcheckSettings spellcheck = 101;
	 */
	spellcheck?: SpellcheckSettings | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.SearchEngineSettings search_engines = 102;
	 */
	searchEngines?: SearchEngineSettings | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.PermissionLayoutSettings permission_layout = 103;
	 */
	permissionLayout?: PermissionLayoutSettings | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.GuildMemberLayoutSettings guild_member_layout = 104;
	 */
	guildMemberLayout?: GuildMemberLayoutSettings | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.GuildFolderExpandedState guild_folders = 105;
	 */
	guildFolders?: GuildFolderExpandedState | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.HiddenGuildListButtons hidden_guild_buttons = 106;
	 */
	hiddenGuildButtons?: HiddenGuildListButtons | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.KeyboardModeIntroState keyboard_mode_intro = 107;
	 */
	keyboardModeIntro?: KeyboardModeIntroState | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.InputMonitoringPromptsState input_monitoring = 108;
	 */
	inputMonitoring?: InputMonitoringPromptsState | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.VoicePromptsState voice_prompts = 109;
	 */
	voicePrompts?: VoicePromptsState | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.SudoPromptState sudo_prompt = 110;
	 */
	sudoPrompt?: SudoPromptState | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.KeybindSettings keybinds = 111;
	 */
	keybinds?: KeybindSettings | undefined;
};

/**
 * Describes the message fluxer.user.preferences.v1.SyncedPreferences.
 * Use `create(SyncedPreferencesSchema)` to create a new message.
 */
export const SyncedPreferencesSchema: GenMessage<SyncedPreferences> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 0);

/**
 * @generated from message fluxer.user.preferences.v1.SpellcheckSettings
 */
export type SpellcheckSettings = Message<'fluxer.user.preferences.v1.SpellcheckSettings'> & {
	/**
	 * @generated from field: optional bool enabled = 1;
	 */
	enabled?: boolean | undefined;

	/**
	 * @generated from field: repeated string languages = 2;
	 */
	languages: Array<string>;

	/**
	 * @generated from field: repeated string personal_dictionary = 3;
	 */
	personalDictionary: Array<string>;

	/**
	 * @generated from field: optional bool auto_detect = 4;
	 */
	autoDetect?: boolean | undefined;

	/**
	 * @generated from field: optional string engine = 5;
	 */
	engine?: string | undefined;
};

/**
 * Describes the message fluxer.user.preferences.v1.SpellcheckSettings.
 * Use `create(SpellcheckSettingsSchema)` to create a new message.
 */
export const SpellcheckSettingsSchema: GenMessage<SpellcheckSettings> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 1);

/**
 * @generated from message fluxer.user.preferences.v1.SearchEngineSettings
 */
export type SearchEngineSettings = Message<'fluxer.user.preferences.v1.SearchEngineSettings'> & {
	/**
	 * @generated from field: optional string text_search_engine_id = 1;
	 */
	textSearchEngineId?: string | undefined;

	/**
	 * @generated from field: optional string reverse_image_search_engine_id = 2;
	 */
	reverseImageSearchEngineId?: string | undefined;

	/**
	 * @generated from field: optional string translation_provider_id = 3;
	 */
	translationProviderId?: string | undefined;
};

/**
 * Describes the message fluxer.user.preferences.v1.SearchEngineSettings.
 * Use `create(SearchEngineSettingsSchema)` to create a new message.
 */
export const SearchEngineSettingsSchema: GenMessage<SearchEngineSettings> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 2);

/**
 * @generated from message fluxer.user.preferences.v1.PrivacyPreferences
 */
export type PrivacyPreferences = Message<'fluxer.user.preferences.v1.PrivacyPreferences'> & {
	/**
	 * @generated from field: bool disable_stream_previews = 1;
	 */
	disableStreamPreviews: boolean;

	/**
	 * @generated from field: optional bool show_active_now = 2;
	 */
	showActiveNow?: boolean | undefined;

	/**
	 * @generated from field: optional bool preupload_message_attachments = 3;
	 */
	preuploadMessageAttachments?: boolean | undefined;
};

/**
 * Describes the message fluxer.user.preferences.v1.PrivacyPreferences.
 * Use `create(PrivacyPreferencesSchema)` to create a new message.
 */
export const PrivacyPreferencesSchema: GenMessage<PrivacyPreferences> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 3);

/**
 * @generated from message fluxer.user.preferences.v1.LocalUserSpamOverrides
 */
export type LocalUserSpamOverrides = Message<'fluxer.user.preferences.v1.LocalUserSpamOverrides'> & {
	/**
	 * @generated from field: repeated string spammer_user_ids = 1;
	 */
	spammerUserIds: Array<string>;

	/**
	 * @generated from field: repeated string not_spammer_user_ids = 2;
	 */
	notSpammerUserIds: Array<string>;
};

/**
 * Describes the message fluxer.user.preferences.v1.LocalUserSpamOverrides.
 * Use `create(LocalUserSpamOverridesSchema)` to create a new message.
 */
export const LocalUserSpamOverridesSchema: GenMessage<LocalUserSpamOverrides> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 4);

/**
 * @generated from message fluxer.user.preferences.v1.TextualPreviewSettings
 */
export type TextualPreviewSettings = Message<'fluxer.user.preferences.v1.TextualPreviewSettings'> & {
	/**
	 * @generated from field: bool wrap_text = 1;
	 */
	wrapText: boolean;
};

/**
 * Describes the message fluxer.user.preferences.v1.TextualPreviewSettings.
 * Use `create(TextualPreviewSettingsSchema)` to create a new message.
 */
export const TextualPreviewSettingsSchema: GenMessage<TextualPreviewSettings> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 5);

/**
 * @generated from message fluxer.user.preferences.v1.SidebarPreferences
 */
export type SidebarPreferences = Message<'fluxer.user.preferences.v1.SidebarPreferences'> & {
	/**
	 * @generated from field: bool inline_dms_collapsed = 1;
	 */
	inlineDmsCollapsed: boolean;

	/**
	 * @generated from field: optional bool show_collapsed_unread_dms_badge = 2;
	 */
	showCollapsedUnreadDmsBadge?: boolean | undefined;

	/**
	 * @generated from field: optional bool show_incoming_friend_request_badge = 3;
	 */
	showIncomingFriendRequestBadge?: boolean | undefined;
};

/**
 * Describes the message fluxer.user.preferences.v1.SidebarPreferences.
 * Use `create(SidebarPreferencesSchema)` to create a new message.
 */
export const SidebarPreferencesSchema: GenMessage<SidebarPreferences> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 6);

/**
 * @generated from message fluxer.user.preferences.v1.MemberListState
 */
export type MemberListState = Message<'fluxer.user.preferences.v1.MemberListState'> & {
	/**
	 * @generated from field: optional bool members_open = 1;
	 */
	membersOpen?: boolean | undefined;
};

/**
 * Describes the message fluxer.user.preferences.v1.MemberListState.
 * Use `create(MemberListStateSchema)` to create a new message.
 */
export const MemberListStateSchema: GenMessage<MemberListState> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 7);

/**
 * @generated from message fluxer.user.preferences.v1.UnreadChannelsState
 */
export type UnreadChannelsState = Message<'fluxer.user.preferences.v1.UnreadChannelsState'> & {
	/**
	 * @generated from field: repeated string collapsed_channel_ids = 1;
	 */
	collapsedChannelIds: Array<string>;
};

/**
 * Describes the message fluxer.user.preferences.v1.UnreadChannelsState.
 * Use `create(UnreadChannelsStateSchema)` to create a new message.
 */
export const UnreadChannelsStateSchema: GenMessage<UnreadChannelsState> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 8);

/**
 * @generated from message fluxer.user.preferences.v1.RecentMentionsSettings
 */
export type RecentMentionsSettings = Message<'fluxer.user.preferences.v1.RecentMentionsSettings'> & {
	/**
	 * @generated from field: optional bool include_everyone = 1;
	 */
	includeEveryone?: boolean | undefined;

	/**
	 * @generated from field: optional bool include_roles = 2;
	 */
	includeRoles?: boolean | undefined;

	/**
	 * @generated from field: optional bool include_guilds = 3;
	 */
	includeGuilds?: boolean | undefined;
};

/**
 * Describes the message fluxer.user.preferences.v1.RecentMentionsSettings.
 * Use `create(RecentMentionsSettingsSchema)` to create a new message.
 */
export const RecentMentionsSettingsSchema: GenMessage<RecentMentionsSettings> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 9);

/**
 * @generated from message fluxer.user.preferences.v1.MentionFrecencyState
 */
export type MentionFrecencyState = Message<'fluxer.user.preferences.v1.MentionFrecencyState'> & {
	/**
	 * @generated from field: repeated fluxer.user.preferences.v1.MentionFrecencyState.Scope scopes = 1;
	 */
	scopes: Array<MentionFrecencyState_Scope>;
};

/**
 * Describes the message fluxer.user.preferences.v1.MentionFrecencyState.
 * Use `create(MentionFrecencyStateSchema)` to create a new message.
 */
export const MentionFrecencyStateSchema: GenMessage<MentionFrecencyState> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 10);

/**
 * @generated from message fluxer.user.preferences.v1.MentionFrecencyState.Entry
 */
export type MentionFrecencyState_Entry = Message<'fluxer.user.preferences.v1.MentionFrecencyState.Entry'> & {
	/**
	 * @generated from field: string user_id = 1;
	 */
	userId: string;

	/**
	 * @generated from field: uint32 count = 2;
	 */
	count: number;

	/**
	 * @generated from field: int64 last_at_ms = 3;
	 */
	lastAtMs: bigint;
};

/**
 * Describes the message fluxer.user.preferences.v1.MentionFrecencyState.Entry.
 * Use `create(MentionFrecencyState_EntrySchema)` to create a new message.
 */
export const MentionFrecencyState_EntrySchema: GenMessage<MentionFrecencyState_Entry> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 10, 0);

/**
 * @generated from message fluxer.user.preferences.v1.MentionFrecencyState.Scope
 */
export type MentionFrecencyState_Scope = Message<'fluxer.user.preferences.v1.MentionFrecencyState.Scope'> & {
	/**
	 * @generated from field: string guild_id = 1;
	 */
	guildId: string;

	/**
	 * @generated from field: repeated fluxer.user.preferences.v1.MentionFrecencyState.Entry entries = 2;
	 */
	entries: Array<MentionFrecencyState_Entry>;
};

/**
 * Describes the message fluxer.user.preferences.v1.MentionFrecencyState.Scope.
 * Use `create(MentionFrecencyState_ScopeSchema)` to create a new message.
 */
export const MentionFrecencyState_ScopeSchema: GenMessage<MentionFrecencyState_Scope> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 10, 1);

/**
 * @generated from message fluxer.user.preferences.v1.FavoritesState
 */
export type FavoritesState = Message<'fluxer.user.preferences.v1.FavoritesState'> & {
	/**
	 * @generated from field: repeated fluxer.user.preferences.v1.FavoriteChannel channels = 1;
	 */
	channels: Array<FavoriteChannel>;

	/**
	 * @generated from field: repeated fluxer.user.preferences.v1.FavoriteCategory categories = 2;
	 */
	categories: Array<FavoriteCategory>;

	/**
	 * @generated from field: repeated string collapsed_category_ids = 3;
	 */
	collapsedCategoryIds: Array<string>;

	/**
	 * @generated from field: bool hide_muted_channels = 4;
	 */
	hideMutedChannels: boolean;

	/**
	 * @generated from field: bool muted = 5;
	 */
	muted: boolean;
};

/**
 * Describes the message fluxer.user.preferences.v1.FavoritesState.
 * Use `create(FavoritesStateSchema)` to create a new message.
 */
export const FavoritesStateSchema: GenMessage<FavoritesState> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 11);

/**
 * @generated from message fluxer.user.preferences.v1.FavoriteChannel
 */
export type FavoriteChannel = Message<'fluxer.user.preferences.v1.FavoriteChannel'> & {
	/**
	 * @generated from field: string channel_id = 1;
	 */
	channelId: string;

	/**
	 * @generated from field: string guild_id = 2;
	 */
	guildId: string;

	/**
	 * @generated from field: optional string parent_id = 3;
	 */
	parentId?: string | undefined;

	/**
	 * @generated from field: int32 position = 4;
	 */
	position: number;

	/**
	 * @generated from field: optional string nickname = 5;
	 */
	nickname?: string | undefined;
};

/**
 * Describes the message fluxer.user.preferences.v1.FavoriteChannel.
 * Use `create(FavoriteChannelSchema)` to create a new message.
 */
export const FavoriteChannelSchema: GenMessage<FavoriteChannel> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 12);

/**
 * @generated from message fluxer.user.preferences.v1.FavoriteCategory
 */
export type FavoriteCategory = Message<'fluxer.user.preferences.v1.FavoriteCategory'> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: int32 position = 3;
	 */
	position: number;
};

/**
 * Describes the message fluxer.user.preferences.v1.FavoriteCategory.
 * Use `create(FavoriteCategorySchema)` to create a new message.
 */
export const FavoriteCategorySchema: GenMessage<FavoriteCategory> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 13);

/**
 * @generated from message fluxer.user.preferences.v1.NagbarDismissals
 */
export type NagbarDismissals = Message<'fluxer.user.preferences.v1.NagbarDismissals'> & {
	/**
	 * @generated from field: bool ios_install = 1;
	 */
	iosInstall: boolean;

	/**
	 * @generated from field: bool pwa_install = 2;
	 */
	pwaInstall: boolean;

	/**
	 * @generated from field: bool push_notification = 3;
	 */
	pushNotification: boolean;

	/**
	 * @generated from field: bool desktop_notification = 4;
	 */
	desktopNotification: boolean;

	/**
	 * @generated from field: bool premium_grace_period = 5;
	 */
	premiumGracePeriod: boolean;

	/**
	 * @generated from field: bool premium_expired = 6;
	 */
	premiumExpired: boolean;

	/**
	 * @generated from field: bool premium_onboarding = 7;
	 */
	premiumOnboarding: boolean;

	/**
	 * @generated from field: bool premium_trial_expiring = 8;
	 */
	premiumTrialExpiring: boolean;

	/**
	 * @generated from field: bool gift_inventory = 9;
	 */
	giftInventory: boolean;

	/**
	 * @generated from field: bool desktop_download = 10;
	 */
	desktopDownload: boolean;

	/**
	 * @generated from field: bool guild_membership_cta = 11;
	 */
	guildMembershipCta: boolean;

	/**
	 * @generated from field: bool visionary_mfa = 12;
	 */
	visionaryMfa: boolean;

	/**
	 * @generated from field: bool legacy_phone_unlink = 14;
	 */
	legacyPhoneUnlink: boolean;

	/**
	 * @generated from field: map<string, bool> pending_bulk_deletion = 15;
	 */
	pendingBulkDeletion: {[key: string]: boolean};

	/**
	 * @generated from field: map<string, bool> invites_disabled = 16;
	 */
	invitesDisabled: {[key: string]: boolean};

	/**
	 * @generated from field: map<string, bool> guild_mfa_requirement = 17;
	 */
	guildMfaRequirement: {[key: string]: boolean};
};

/**
 * Describes the message fluxer.user.preferences.v1.NagbarDismissals.
 * Use `create(NagbarDismissalsSchema)` to create a new message.
 */
export const NagbarDismissalsSchema: GenMessage<NagbarDismissals> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 14);

/**
 * @generated from message fluxer.user.preferences.v1.DismissedUpsells
 */
export type DismissedUpsells = Message<'fluxer.user.preferences.v1.DismissedUpsells'> & {
	/**
	 * @generated from field: bool picker_premium = 1;
	 */
	pickerPremium: boolean;
};

/**
 * Describes the message fluxer.user.preferences.v1.DismissedUpsells.
 * Use `create(DismissedUpsellsSchema)` to create a new message.
 */
export const DismissedUpsellsSchema: GenMessage<DismissedUpsells> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 15);

/**
 * @generated from message fluxer.user.preferences.v1.GuildNsfwAgreements
 */
export type GuildNsfwAgreements = Message<'fluxer.user.preferences.v1.GuildNsfwAgreements'> & {
	/**
	 * @generated from field: repeated string agreed_channel_ids = 1;
	 */
	agreedChannelIds: Array<string>;

	/**
	 * @generated from field: repeated string agreed_guild_ids = 2;
	 */
	agreedGuildIds: Array<string>;

	/**
	 * @generated from field: repeated string agreed_category_ids = 3;
	 */
	agreedCategoryIds: Array<string>;
};

/**
 * Describes the message fluxer.user.preferences.v1.GuildNsfwAgreements.
 * Use `create(GuildNsfwAgreementsSchema)` to create a new message.
 */
export const GuildNsfwAgreementsSchema: GenMessage<GuildNsfwAgreements> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 16);

/**
 * @generated from message fluxer.user.preferences.v1.WhatsNewState
 */
export type WhatsNewState = Message<'fluxer.user.preferences.v1.WhatsNewState'> & {
	/**
	 * @generated from field: optional string last_dismissed_entry_id = 1;
	 */
	lastDismissedEntryId?: string | undefined;
};

/**
 * Describes the message fluxer.user.preferences.v1.WhatsNewState.
 * Use `create(WhatsNewStateSchema)` to create a new message.
 */
export const WhatsNewStateSchema: GenMessage<WhatsNewState> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 17);

/**
 * @generated from message fluxer.user.preferences.v1.PermissionLayoutSettings
 */
export type PermissionLayoutSettings = Message<'fluxer.user.preferences.v1.PermissionLayoutSettings'> & {
	/**
	 * @generated from field: fluxer.user.preferences.v1.PermissionLayoutMode layout = 1;
	 */
	layout: PermissionLayoutMode;

	/**
	 * @generated from field: fluxer.user.preferences.v1.PermissionGridMode grid = 2;
	 */
	grid: PermissionGridMode;
};

/**
 * Describes the message fluxer.user.preferences.v1.PermissionLayoutSettings.
 * Use `create(PermissionLayoutSettingsSchema)` to create a new message.
 */
export const PermissionLayoutSettingsSchema: GenMessage<PermissionLayoutSettings> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 18);

/**
 * @generated from message fluxer.user.preferences.v1.GuildMemberLayoutSettings
 */
export type GuildMemberLayoutSettings = Message<'fluxer.user.preferences.v1.GuildMemberLayoutSettings'> & {
	/**
	 * @generated from field: fluxer.user.preferences.v1.GuildMemberViewMode mode = 1;
	 */
	mode: GuildMemberViewMode;
};

/**
 * Describes the message fluxer.user.preferences.v1.GuildMemberLayoutSettings.
 * Use `create(GuildMemberLayoutSettingsSchema)` to create a new message.
 */
export const GuildMemberLayoutSettingsSchema: GenMessage<GuildMemberLayoutSettings> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 19);

/**
 * @generated from message fluxer.user.preferences.v1.GuildFolderExpandedState
 */
export type GuildFolderExpandedState = Message<'fluxer.user.preferences.v1.GuildFolderExpandedState'> & {
	/**
	 * @generated from field: repeated fixed64 expanded_folder_ids = 1;
	 */
	expandedFolderIds: Array<bigint>;
};

/**
 * Describes the message fluxer.user.preferences.v1.GuildFolderExpandedState.
 * Use `create(GuildFolderExpandedStateSchema)` to create a new message.
 */
export const GuildFolderExpandedStateSchema: GenMessage<GuildFolderExpandedState> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 20);

/**
 * @generated from message fluxer.user.preferences.v1.HiddenGuildListButtons
 */
export type HiddenGuildListButtons = Message<'fluxer.user.preferences.v1.HiddenGuildListButtons'> & {
	/**
	 * @generated from field: bool download_button = 1;
	 */
	downloadButton: boolean;

	/**
	 * @generated from field: bool help_button = 2;
	 */
	helpButton: boolean;
};

/**
 * Describes the message fluxer.user.preferences.v1.HiddenGuildListButtons.
 * Use `create(HiddenGuildListButtonsSchema)` to create a new message.
 */
export const HiddenGuildListButtonsSchema: GenMessage<HiddenGuildListButtons> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 21);

/**
 * @generated from message fluxer.user.preferences.v1.KeyboardModeIntroState
 */
export type KeyboardModeIntroState = Message<'fluxer.user.preferences.v1.KeyboardModeIntroState'> & {
	/**
	 * @generated from field: bool seen = 1;
	 */
	seen: boolean;
};

/**
 * Describes the message fluxer.user.preferences.v1.KeyboardModeIntroState.
 * Use `create(KeyboardModeIntroStateSchema)` to create a new message.
 */
export const KeyboardModeIntroStateSchema: GenMessage<KeyboardModeIntroState> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 22);

/**
 * @generated from message fluxer.user.preferences.v1.InputMonitoringPromptsState
 */
export type InputMonitoringPromptsState = Message<'fluxer.user.preferences.v1.InputMonitoringPromptsState'> & {
	/**
	 * @generated from field: bool seen_cta = 1;
	 */
	seenCta: boolean;
};

/**
 * Describes the message fluxer.user.preferences.v1.InputMonitoringPromptsState.
 * Use `create(InputMonitoringPromptsStateSchema)` to create a new message.
 */
export const InputMonitoringPromptsStateSchema: GenMessage<InputMonitoringPromptsState> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 23);

/**
 * @generated from message fluxer.user.preferences.v1.VoicePromptsState
 */
export type VoicePromptsState = Message<'fluxer.user.preferences.v1.VoicePromptsState'> & {
	/**
	 * @generated from field: bool skip_hide_own_camera_confirm = 1;
	 */
	skipHideOwnCameraConfirm: boolean;

	/**
	 * @generated from field: bool skip_hide_own_screenshare_confirm = 2;
	 */
	skipHideOwnScreenshareConfirm: boolean;
};

/**
 * Describes the message fluxer.user.preferences.v1.VoicePromptsState.
 * Use `create(VoicePromptsStateSchema)` to create a new message.
 */
export const VoicePromptsStateSchema: GenMessage<VoicePromptsState> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 24);

/**
 * @generated from message fluxer.user.preferences.v1.SudoPromptState
 */
export type SudoPromptState = Message<'fluxer.user.preferences.v1.SudoPromptState'> & {
	/**
	 * @generated from field: optional fluxer.user.preferences.v1.MfaMethod last_used_mfa_method = 1;
	 */
	lastUsedMfaMethod?: MfaMethod | undefined;
};

/**
 * Describes the message fluxer.user.preferences.v1.SudoPromptState.
 * Use `create(SudoPromptStateSchema)` to create a new message.
 */
export const SudoPromptStateSchema: GenMessage<SudoPromptState> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 25);

/**
 * @generated from message fluxer.user.preferences.v1.KeybindSettings
 */
export type KeybindSettings = Message<'fluxer.user.preferences.v1.KeybindSettings'> & {
	/**
	 * @generated from field: repeated fluxer.user.preferences.v1.CustomKeybind custom_keybinds = 1;
	 */
	customKeybinds: Array<CustomKeybind>;

	/**
	 * @generated from field: string transmit_mode = 2;
	 */
	transmitMode: string;

	/**
	 * @generated from field: optional uint32 push_to_talk_release_delay_ms = 3;
	 */
	pushToTalkReleaseDelayMs?: number | undefined;
};

/**
 * Describes the message fluxer.user.preferences.v1.KeybindSettings.
 * Use `create(KeybindSettingsSchema)` to create a new message.
 */
export const KeybindSettingsSchema: GenMessage<KeybindSettings> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 26);

/**
 * @generated from message fluxer.user.preferences.v1.CustomKeybind
 */
export type CustomKeybind = Message<'fluxer.user.preferences.v1.CustomKeybind'> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: optional string action = 2;
	 */
	action?: string | undefined;

	/**
	 * @generated from field: fluxer.user.preferences.v1.KeybindCombo combo = 3;
	 */
	combo?: KeybindCombo | undefined;

	/**
	 * @generated from field: bool enabled = 4;
	 */
	enabled: boolean;
};

/**
 * Describes the message fluxer.user.preferences.v1.CustomKeybind.
 * Use `create(CustomKeybindSchema)` to create a new message.
 */
export const CustomKeybindSchema: GenMessage<CustomKeybind> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 27);

/**
 * @generated from message fluxer.user.preferences.v1.KeybindCombo
 */
export type KeybindCombo = Message<'fluxer.user.preferences.v1.KeybindCombo'> & {
	/**
	 * @generated from field: string key = 1;
	 */
	key: string;

	/**
	 * @generated from field: optional string code = 2;
	 */
	code?: string | undefined;

	/**
	 * @generated from field: bool ctrl_or_meta = 3;
	 */
	ctrlOrMeta: boolean;

	/**
	 * @generated from field: bool ctrl = 4;
	 */
	ctrl: boolean;

	/**
	 * @generated from field: bool alt = 5;
	 */
	alt: boolean;

	/**
	 * @generated from field: bool shift = 6;
	 */
	shift: boolean;

	/**
	 * @generated from field: bool meta = 7;
	 */
	meta: boolean;

	/**
	 * @generated from field: optional bool global = 8;
	 */
	global?: boolean | undefined;

	/**
	 * @generated from field: optional bool enabled = 9;
	 */
	enabled?: boolean | undefined;

	/**
	 * @generated from field: bool modifier_only = 10;
	 */
	modifierOnly: boolean;

	/**
	 * @generated from field: bool both_sides = 11;
	 */
	bothSides: boolean;

	/**
	 * @generated from field: optional uint32 mouse_button = 12;
	 */
	mouseButton?: number | undefined;

	/**
	 * @generated from field: optional uint32 gamepad_button = 13;
	 */
	gamepadButton?: number | undefined;
};

/**
 * Describes the message fluxer.user.preferences.v1.KeybindCombo.
 * Use `create(KeybindComboSchema)` to create a new message.
 */
export const KeybindComboSchema: GenMessage<KeybindCombo> =
	/*@__PURE__*/
	messageDesc(file_fluxer_user_preferences_v1_preferences, 28);

/**
 * @generated from enum fluxer.user.preferences.v1.PermissionLayoutMode
 */
export enum PermissionLayoutMode {
	/**
	 * @generated from enum value: PERMISSION_LAYOUT_MODE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: PERMISSION_LAYOUT_MODE_COMFY = 1;
	 */
	COMFY = 1,

	/**
	 * @generated from enum value: PERMISSION_LAYOUT_MODE_DENSE = 2;
	 */
	DENSE = 2,
}

/**
 * Describes the enum fluxer.user.preferences.v1.PermissionLayoutMode.
 */
export const PermissionLayoutModeSchema: GenEnum<PermissionLayoutMode> =
	/*@__PURE__*/
	enumDesc(file_fluxer_user_preferences_v1_preferences, 0);

/**
 * @generated from enum fluxer.user.preferences.v1.PermissionGridMode
 */
export enum PermissionGridMode {
	/**
	 * @generated from enum value: PERMISSION_GRID_MODE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: PERMISSION_GRID_MODE_SINGLE = 1;
	 */
	SINGLE = 1,

	/**
	 * @generated from enum value: PERMISSION_GRID_MODE_GRID = 2;
	 */
	GRID = 2,
}

/**
 * Describes the enum fluxer.user.preferences.v1.PermissionGridMode.
 */
export const PermissionGridModeSchema: GenEnum<PermissionGridMode> =
	/*@__PURE__*/
	enumDesc(file_fluxer_user_preferences_v1_preferences, 1);

/**
 * @generated from enum fluxer.user.preferences.v1.GuildMemberViewMode
 */
export enum GuildMemberViewMode {
	/**
	 * @generated from enum value: GUILD_MEMBER_VIEW_MODE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: GUILD_MEMBER_VIEW_MODE_TABLE = 1;
	 */
	TABLE = 1,

	/**
	 * @generated from enum value: GUILD_MEMBER_VIEW_MODE_GRID = 2;
	 */
	GRID = 2,
}

/**
 * Describes the enum fluxer.user.preferences.v1.GuildMemberViewMode.
 */
export const GuildMemberViewModeSchema: GenEnum<GuildMemberViewMode> =
	/*@__PURE__*/
	enumDesc(file_fluxer_user_preferences_v1_preferences, 2);

/**
 * @generated from enum fluxer.user.preferences.v1.MfaMethod
 */
export enum MfaMethod {
	/**
	 * @generated from enum value: MFA_METHOD_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: MFA_METHOD_TOTP = 1;
	 */
	TOTP = 1,

	/**
	 * @generated from enum value: MFA_METHOD_WEBAUTHN = 3;
	 */
	WEBAUTHN = 3,
}

/**
 * Describes the enum fluxer.user.preferences.v1.MfaMethod.
 */
export const MfaMethodSchema: GenEnum<MfaMethod> =
	/*@__PURE__*/
	enumDesc(file_fluxer_user_preferences_v1_preferences, 3);
